import { put } from "redux-saga/effects";

import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";

export function* sellItemSaga({
  resourceId,
  amount,
  marketType
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "sellItem",
      resource: resourceId,
      amount,
      mt: marketType
    });

    const { data } = JSON.parse(response.data);
    const {
      resources,
      resourceBalances,
      marketItems,
      marketUsage,
      famine,
      army
    } = data;

    yield put(actions.updateResources({
      resources,
      resourceBalances
    }));

    yield put(actions.updateState({
      famine,
      marketItems,
      marketUsage,
      army
    }));

    yield put(actions.closeDialog());
  } catch (error) {
    console.log(error.message);
  }
}

export function* cancelItemSaga({
  itemId
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "cancelMarketItem",
      itemId
    });

    const { data } = JSON.parse(response.data);
    const {
      resources,
      resourceBalances,
      marketItems,
      marketUsage,
      famine,
      army
    } = data;

    yield put(actions.updateResources({
      resources,
      resourceBalances
    }));

    yield put(actions.updateState({
      army,
      famine,
      marketItems,
      marketUsage
    }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* buyItemSaga({
  itemId,
  amount
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "buyItem",
      itemId,
      amount
    });

    const { data } = JSON.parse(response.data);
    const {
      resources,
      resourceBalances,
      marketItems,
      marketUsage,
      famine,
      army
    } = data;

    yield put(actions.updateResources({
      resources,
      resourceBalances
    }));

    yield put(actions.updateState({
      famine,
      marketItems,
      marketUsage,
      army
    }));
  } catch (error) {
    console.log(error.message);
  }
}
